/*
API requests to the dd backend
*/
import { apiRequest } from '../../plugins/core/dd.data.connect.js'

export const getCurrentTraffic = (data, params) => {
  var p = new Promise((resolve, reject) => {
    apiRequest('GET','/traffic', data, params).then((res) => {
      resolve(res)
    }).catch((e) => {      
      reject(e)
    })
  })
  return p
}

